import React from 'react';
import { withNotifications } from '@econ/ui-elements';
import Loader from '../../shared/components/Loader';
import { useLocalization, t } from '../../shared/components/l10n/l10n';
import { setLocale } from 'yup';

const globalTextIds = [
    'BUTTON_OK',
    'BUTTON_SAVE',
    'BUTTON_CANCEL',
    'BUTTON_CREATE_ENTRY',
    'BUTTON_NEXT',
    'BUTTON_BACK',
    'FORM_LEDGER_EDITFIELD_DISTRIBUTION',
    'NOTIFICATION_SUCCESS',
    'NOTIFICATION_LOADING',
    'NOTIFICATION_INFORMATION',
    'NOTIFICATION_WARNING',
    'NOTIFICATION_ERROR',
    'SYSTEMERROR_HEADLINE',
    'FORM_FIELD_LABEL_ACCOUNT',
    'FORM_FIELD_LABEL_ACCOUNT_NUMBER',
    'FORM_FIELD_LABEL_ACCOUNTING_YEAR',
    'FORM_FIELD_LABEL_ACCOUNT_TYPE',
    'FORM_FIELD_LABEL_NUMBER',
    'FORM_FIELD_LABEL_NAME',
    'FORM_FIELD_LABEL_USER',
    'FORM_FIELD_LABEL_CONTRA_ACCOUNT_NUMBER',
    'FORM_FIELD_LABEL_VAT_ACCOUNT_CODE',
    'FORM_FIELD_LABEL_VAT_CONTRA_ACCOUNT_CODE',
    'FORM_FIELD_LABEL_TOTAL_FROM_ACCOUNT',
    'FORM_FIELD_LABEL_OPENING_ACCOUNT',
    'FORM_FIELD_LABEL_REALISATION_ACCOUNT',
    'FORM_FIELD_LABEL_KEY_FIGURE_CODE',
    'FORM_FIELD_LABEL_AMOUNT',
    'FORM_FIELD_LABEL_CURRENCY',
    'FORM_FIELD_LABEL_CURRENCY_EXCHANGE_RATE',
    'FORM_FIELD_LABEL_DATE',
    'FORM_FIELD_LABEL_DUE_DATE',
    'FORM_FIELD_LABEL_ENTRY_TYPE',
    'FORM_FIELD_LABEL_INVOICE_NUMBER',
    'FORM_FIELD_LABEL_SUPPLIER_NUMBER',
    'FORM_FIELD_LABEL_CUSTOMER_NUMBER',
    'FORM_FIELD_LABEL_DEPARTMENT_NUMBER',
    'FORM_FIELD_LABEL_ENTRY_NUMBER',
    'FORM_FIELD_LABEL_DEBIT_CREDIT',
    'FORM_FIELD_LABEL_TEXT',
    'FORM_FIELD_LABEL_ACCRUALS',
    'FORM_FIELD_LABEL_ACCRUALS_START_DATE',
    'FORM_FIELD_LABEL_ACCRUALS_END_DATE',
    'FORM_FIELD_LABEL_DIMENSION_UNIT1',
    'FORM_FIELD_LABEL_DIMENSION_UNIT2',
    'FORM_FIELD_LABEL_DIMENSION_QUANTITY1',
    'FORM_FIELD_LABEL_DIMENSION_QUANTITY2',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_FI_SUPPLIER_NUMBER',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_OCR_LINE',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_MESSAGE',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_GIRO_ACCOUNT',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_ACCOUNT',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_IBAN_NUMBER',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_OCR_OPTIONAL_MESSAGE',
    'FORM_FIELD_LABEL_PROJECT',
    'FORM_FIELD_LABEL_PROJECT_NUMBER',
    'FORM_FIELD_LABEL_COST_TYPE_NUMBER',
    'FORM_FIELD_LABEL_EMPLOYEE_NUMBER',
    'FORM_FIELD_LABEL_ACCESS',
    'FORM_FIELD_LABEL_BLOCK_DIRECT_ENTRIES',
    'FORM_FIELD_LABEL_TOTAL_INTERVALS',
    'FORM_FIELD_LABEL_GROUP',
    'FORM_FIELD_LABEL_JOURNAL',
    'FORM_FIELD_LABEL_LAYOUT',
    'FORM_FIELD_LABEL_LANGUAGE',
    'FORM_FIELD_LABEL_VAT_ZONE',
    'FORM_FIELD_LABEL_PHONE',
    'FORM_FIELD_LABEL_EMAIL',
    'FORM_FIELD_LABEL_ADDRESS',
    'FORM_FIELD_LABEL_ADDRESS_ZIP_CODE',
    'FORM_FIELD_LABEL_ADDRESS_TOWN',
    'FORM_FIELD_LABEL_ADDRESS_COUNTRY',
    'FORM_FIELD_LABEL_COST_ACCOUNT',
    'FORM_FIELD_LABEL_AUTOMATIC_TEXT',
    'FORM_FIELD_LABEL_CVR',
    'FORM_FIELD_LABEL_PAYMENT_TERMS',
    'FORM_FIELD_LABEL_ATTENTION',
    'FORM_FIELD_LABEL_YOUR_REF',
    'FORM_FIELD_LABEL_OUR_REF',
    'FORM_FIELD_LABEL_TYPE',
    'FORM_FIELD_LABEL_MARKUP_PERCENTAGE',
    'FORM_FIELD_LABEL_BANK_ACCOUNT',
    'FORM_FIELD_LABEL_ACCOUNT_ONGOING',
    'FORM_FIELD_LABEL_ACCOUNT_CLOSED',
    'FORM_FIELD_LABEL_ACCESS_OPEN',
    'FORM_FIELD_LABEL_ACCESS_BARRED',
    'FORM_FIELD_LABEL_DEBIT',
    'FORM_FIELD_LABEL_CREDIT',
    'FORM_FIELD_LABEL_REQUIRED',
    'FORM_FIELD_LABEL_ACCESS_FROM_INVENTORY',
    'FORM_FIELD_LABEL_ACCOUNT_FOR_FREIGHT',
    'FORM_FIELD_LABEL_ACCOUNT_FOR_CHARGE',
    'FORM_FIELD_LABEL_ACCOUNT_FOR_BULK_DISCOUNT',
    'FORM_FIELD_LABEL_CONTRA_ACCOUNT_SUPPLIER_MARKUP',
    'FORM_FIELD_LABEL_CONTRA_ACCOUNT_COST_PRICE_MARKUP',
    'FORM_FIELD_LABEL_ALLOCATE_TO_PRODUCTS',
    'FORM_FIELD_LABEL_SUPPLIER_GROUP',
    'FORM_FIELD_LABEL_AUTOMATIC_NUMBERING',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_PAYMENT_DATE',
    'FORM_FIELD_LABEL_PAYMENT_DETAILS_CASH_ACCOUNT',
    'FIREBIRD_FORM_SUPPLIER_GROUP_TAB_STOCK',
    'FIREBIRD_FORM_CUSTOMERS_TAB_GENERAL',
    'FIREBIRD_FORM_SUPPLIERS_TAB_REFERENCESANDPAYMENT',
    'FIREBIRD_FORM_CUSTOMERS_TAB_ADDITIONAL',
    'FIREBIRD_FORM_CUSTOMERS_TAB_DELIVERY',
    'FIREBIRD_FORM_SUPPLIERS_TAB_GENERAL',
    'FIREBIRD_LEFTMENU_INVENTORY_SUPPLIERS_GROUP',
    'MODAL_CURRENCIES_TITLE',
    'MODAL_CHART_OF_ACCOUNTS_TITLE',
    'FIREBIRD_LEFTMENU_SALES_DISCOUNTGROUPS',
    'LEFTMENU_SETTINGS_DEPARTMENTS',
    'FORM_DELIVERYPLACE_HEADLINE',
    'FIREBIRD_FORM_CUSTOMERS_LISTHEADLINE',
    'FORM_EXPENSES_HEADLINE',
    'FORM_EXPENSEGROUPS_HEADLINE',
    'FORM_CONTACTS_HEADLINE',
    'FORM_EMPLOYEEGROUPS_HEADLINE',
    'FORM_PRICEGROUP_HEADLINE',
    'FORM_CASETASKEMPLOYEES_HEADLINE',
    'FORM_CASES_APPLETHEADLINE',
    'DOCUMENT_INBOX_WORKFLOW_ATTACH_TO_ENTRY_BUTTON',
    'DOCUMENT_INBOX_DOCUMENT_TOOLTIP_PRINT_DOCUMENT',
    'DOCUMENT_INBOX_DOCUMENT_TOOLTIP_DRAG_DOCUMENT',
    'DOCUMENT_INBOX_NOTIFICATION_ATTACH_TO_VOUCHER_SUCCESS',
    'DOCUMENT_INBOX_NOTIFICATION_ATTACH_TO_VOUCHER_ERROR',
    'DOCUMENT_INBOX_TOOLTIP_MOVE_TO_TOP',
    'DOCUMENT_INBOX_TOOLTIP_MOVE_UP',
    'DOCUMENT_INBOX_TOOLTIP_MOVE_DOWN',
    'DOCUMENT_INBOX_TOOLTIP_MOVE_TO_BOTTOM',
    'FORM_ACCOUNTS_CREATETEXT',
    'FORM_PAYABLES_CREATETEXT',
    'FORM_PAYABLES_CREATETEXT_INLINE',
    'FORM_PAYABLESGROUPS_CREATETEXT',
    'FORM_EMPLOYEES_CREATETEXT',
    'FORM_EMPLOYEEGROUPS_CREATETEXT',
    'FORM_PRICEGROUP_CREATETEXT',
    'FORM_REBATEGROUP_CREATETEXT',
    'FORM_DEPARTMENT_CREATETEXT',
    'FORM_RECEIVABLES_CREATETEXT',
    'FORM_RECEIVABLESGROUPS_CREATETEXT',
    'FORM_EXPENSES_CREATETEXT',
    'FORM_EXPENSEGROUPS_CREATETEXT',
    'FORM_SUPPLIER_SETUP_EDITTEXT',
    'FORM_SUPPLIER_SETUP_SUB_HEADING',
    'FIREBIRD_FORM_COA_TAB_DIMENSION',
    'FORM_FIELD_LABEL_DIMENSION_MANDATORY_DEPARTMENT',
    'FORM_FIELD_LABEL_DIMENSION_MANDATORY_UNIT',
    'MODAL_TITLE_FIND_ENTRY_BY_ACCOUNTING_YEAR',
    'MODAL_FIND_ENTRY_BY_ACCOUNTING_YEAR_FROM_DATE',
    'MODAL_FIND_ENTRY_BY_ACCOUNTING_YEAR_TO_DATE',
    'MODAL_FIND_ENTRY_BY_ACCOUNTING_YEAR_HIDE_ENTRIES_WITH_ATTACHMENT',
    'TABLE_COLUMN_ENTRY_STATUS_BOOKED',
    'TABLE_COLUMN_ENTRY_TYPE',
    'TABLE_COLUMN_ENTRY_NUMBER',
    'TABLE_COLUMN_ENTRY_DATE',
    'TABLE_COLUMN_ENTRY_TEXT',
    'TABLE_COLUMN_ENTRY_AMOUNT',
    'TABLE_COLUMN_ENTRY_ACCOUNT_NUMBER',
    'TABLE_COLUMN_ENTRY_ATTACHMENT',
    'FORM_FIELD_PAYMENT_DETAILS_OPTION_NONE',
    'FORM_FIELD_PAYMENT_DETAILS_OPTION_BANK_TRANSFER',
    'FORM_FIELD_PAYMENT_DETAILS_OPTION_ENTRY_ONLY',
    'SHARED_POSTTYPE_2',
    'SHARED_POSTTYPE_3',
    'SHARED_POSTTYPE_4',
    'SHARED_POSTTYPE_5',
    'SHARED_POSTTYPE_10',
    'ERROR_CODE_E04000',
    'ERROR_CODE_E06830',
    'ERROR_CODE_E06841',
    'ERROR_CODE_E06850',
    'ERROR_CODE_E06880',
    'ERROR_CODE_E06890',
    'ERROR_CODE_E07020',
    'ERROR_CODE_E07031',
    'ERROR_CODE_E07040',
    'ERROR_CODE_E07070',
    'ERROR_CODE_E07090',
    'ERROR_CODE_E07130',
    'ERROR_CODE_E07140',
    'ERROR_CODE_E07150',
    'ERROR_CODE_E07190',
    'ERROR_CODE_E08002',
    'ERROR_CODE_E08003',
    'ERROR_CODE_E08004',
    'ERROR_CODE_E08005',
    'ERROR_CODE_E04030',
    'ERROR_CODE_E06520',
    'FORM_FIELD_ERROR_DATE_NOT_WITHIN_EXISTING_ACCOUNTING_YEAR',
    'FORM_FIELD_ERROR_AT_LEAST_N_CHARACTERS',
    'FORM_FIELD_ERROR_EXACTLY_N_CHARACTERS',
    'FORM_FIELD_ERROR_DUPLICATE_INVOICE_NUMBER',
    'FORM_FIELD_ERROR_TYPE',
    'GUIDED_TOUR_BUTTON_BACK',
    'GUIDED_TOUR_BUTTON_CLOSE',
    'GUIDED_TOUR_BUTTON_DONE',
    'GUIDED_TOUR_BUTTON_NEXT',
    'GUIDED_TOUR_BUTTON_SKIP',
    'FORM_LISTVIEW_FILTER_PLACEHOLDER',
    'INBOX_EXPORT_ENTRIES_FILE_NAME',
    'INBOX_GENERATING_EXPORT_TO_EXCEL',
    'FORM_ASSETS_GROUP_HEADLINE',
    'FORM_ASSETS_GROUP_ADD_NEW',
    'FORM_FIELD_LABEL_ASSETS_GROUP',
    'FORM_FIELD_LABEL_ASSETS_ASSET_NUMBER',
    'FORM_FIELD_LABEL_ASSETS_START_DATE',
    'FORM_FIELD_LABEL_ASSETS_USEFUL_LIFE',
    'FORM_LEDGER_EDITFIELD_ASSETNUMBER_WARNING_ALREADYINUSE',
    'FORM_ASSETS_GROUP_HEADLINE_APPLET',
    'FORM_FIELD_LABEL_USEFUL_LIFE',
    'FORM_FIELD_LABEL_RESIDUAL_VALUE',
    'FORM_FIELD_LABEL_ADDITIONS_ACCOUNT',
    'FORM_FIELD_LABEL_DEPRECIATION_BALANCE_SHEET_ACCOUNT',
    'FORM_FIELD_LABEL_DEPRECIATION_PROFIT_LOSS_ACCOUNT',
    'FORM_FIELD_LABEL_DEPRECIATION_REVERSED_ACCOUNT',
    'FORM_FIELD_LABEL_DISPOSALS_ACCOUNT',
    'FORM_FIELD_LABEL_NET_BOOKED_VALUE_ACCOUNT',
    'FORM_FIELD_LABEL_ADDITIONS_CONTRA_ACCOUNT',
    'FORM_FIELD_LABEL_DEPRECIATION_CONTRA_ACCOUNT',
    'FORM_FIELD_ERROR_ASSETS_AMOUNT_CANNOT_BE_NEGATIVE',
    'LABEL_ELECTRONIC_DOCUMENT',
    'DOCUMENT_MANAGEMENT_DOCUMENT_LIST_PAGE_X_OF_Y',
    'DOCUMENT_MANAGEMENT_DOCUMENT_LIST_X_PAGES',
    'DISTRIBUTION_TEMPLATE_DROPDOWN_OPTION_GROSS',
    'DISTRIBUTION_TEMPLATE_DROPDOWN_OPTION_NET',
    'DISTRIBUTION_TEMPLATE_HEADING',
    'DISTRIBUTION_TEMPLATE_NEW_ROW',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_ACCOUNTNUMBER',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_AMOUNT',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_ACCOUNTNAME',
    'DAYBOOK_NAVIGATION_LIST_DEPARTMENT',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_QUANTITY1',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_QUANTITY2',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_VAT',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_DEBIT_OR_CREDIT',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_GROSS_OR_NET',
    'DISTRIBUTION_TEMPLATE_ROW_COLUMN_HEADING_TEXT',
    'DISTRIBUTION_TEMPLATE_AMOUNT_FOR_DISTRIBUTION',
    'DISTRIBUTION_TEMPLATE_APPLY_TEMPLATE',
    'DISTRIBUTION_TEMPLATE_SAVE_TEMPLATE',
    'DISTRIBUTION_TEMPLATE_NEW_TEMPLATE',
    'DISTRIBUTION_TEMPLATE_REMAINDER',
    'DISTRIBUTION_TEMPLATE_VALIDATION_NOBALANCE',
    'DISTRIBUTION_TEMPLATE_USE_EXISTING_TEMPLATE',
    'DISTRIBUTION_TEMPLATE_SAVE_TITLE',
    'DISTRIBUTION_TEMPLATE_SAVE_TEMPLATENAME',
    'DISTRIBUTION_TEMPLATE_SAVE_AMOUNT',
    'DISTRIBUTION_TEMPLATE_SAVE_TEXT',
    'DISTRIBUTION_TEMPLATE_SAVE_DEPARTMENT',
    'DISTRIBUTION_TEMPLATE_SAVE_QUANTITY1',
    'DISTRIBUTION_TEMPLATE_SAVE_QUANTITY2',
    'DISTRIBUTION_TEMPLATE_VIEW_DOCUMENT',
    'EONBOARDING_CVRVALIDATION_STATUS_MISMATCH_DETAILS',
    'EONBOARDING_CVRVALIDATION_STATUS_INUSE_DETAILS',
    'EONBOARDING_CVRVALIDATION_STATUS_INVALID_DETAILS',
    'EONBOARDING_CVRVALIDATION_CVRSTATUS',
    'EONBOARDING_CVRVALIDATION_COMPANY_NAME',
    'EONBOARDING_CVRVALIDATION_STATUS_INVALID',
    'EONBOARDING_CVRVALIDATION_STATUS_INUSE',
    'EONBOARDING_CVRVALIDATION_STATUS_VALID',
    'EONBOARDING_CVRVALIDATION_STATUS_INVALID_GLN_DETAILS',
    'EONBOARDING_CVRVALIDATION_STATUS_NOT_ELIGIBLE_FOR_FREE_GLN_DETAILS',
    'EONBOARDING_REGISTRATION_ERROR',
    'EONBOARDING_LOOKUP_ERROR',
    'EONBOARDING_TEXT_HEADER',
    'EONBOARDING_TEXT_SUBHEADER',
    'EONBOARDING_TOC_CHECKBOX',
    'EONBOARDING_LEARN_MORE_BUTTON',
    'EONBOARDING_LEARN_MORE_BUTTON_URL',
    'EONBOARDING_ACTIVATE_BUTTON',
    'EONBOARDING_CVR_NUMBER_LABEL',
    'EONBOARDING_SUCCESS_HEADLINE',
    'EONBOARDING_SUCCESS_SUBHEADER',
    'EONBOARDING_SUCCESS_GETSTARTED_BUTTON',
    'EONBOARDING_SUCCESS_CONTACTPOINT_ECOPEDIA',
    'EONBOARDING_SUCCESS_CONTACTPOINT_ECOPEDIA_LINK',
    'EONBOARDING_SUCCESS_CONTACTPOINT_ECOPEDIA_LINK_URL',
    'EONBOARDING_SUCCESS_CONTACTPOINT_SUPPORT',
    'EONBOARDING_SUCCESS_CONTACTPOINT_SUPPORT_PHONENO',
    'EONBOARDING_SPLASH_HEADLINE',
    'EONBOARDING_SPLASH_SUBTITLE',
    'EONBOARDING_SPLASH_SELLINGPOINT_ONE',
    'EONBOARDING_SPLASH_SELLINGPOINT_TWO',
    'EONBOARDING_SPLASH_SELLINGPOINT_THREE',
    'EONBOARDING_SPLASH_LEARN_MORE_BUTTON_TEXT',
    'EONBOARDING_SPLASH_LEARN_MORE_BUTTON_URL',
    'EONBOARDING_SPLASH_CONTINUE_BUTTON_TEXT',
    'LABEL_LANGUAGE_DANISH',
    'LABEL_LANGUAGE_ENGLISH',
    'HANGER_INBOX',
];

function Startup({ children }: React.PropsWithChildren<{}>) {
    const loading = useLocalization(globalTextIds);

    React.useEffect(() => {
        // Place any logic to run at startup here

        if (!loading) {
            setLocale({
                mixed: {
                    required: t`FORM_FIELD_LABEL_REQUIRED`,
                    notType: t`FORM_FIELD_ERROR_TYPE`,
                },
            });
        }
    }, [loading]);

    return loading ? <Loader /> : <>{children}</>;
}

export default withNotifications(Startup);
